export default __webpack_public_path__ + "static/DSC_0112-3aca860fe898bba1e2aba627d27976a3.jpg";